import { createFileRoute } from '@tanstack/react-router';
import JobPublicDetailPage from '@/features/jobs/job-informations-page/JobPublicDetailPage';

export const Route = createFileRoute('/vagas/$jobId')({
  component: JobPublicDetailPage,
});
